<template>
  <div class="notice_w">

    <div class="top d_flex justify_content_sb">
      <div>
        <span class="fz12 c_1A1A1A">{{ isDealed?'成交价':'价格' }}</span>
        <span class="fz24 c_CF3342 font_w_bold">￥{{ itemDetail.currentPrice }}</span>
        <span class="fz12 c_CF3342"> {{ itemDetail.priceUnitDesc }}<span v-if="itemDetail.priceUnit==='zongjia'">({{ priceUnitKey[itemDetail.priceUnit] }})</span></span>
      </div>
      <div class="c_808080 fz14">
        <span>{{ itemDetail.statis.applyCnt }}人报名</span>
        <span style="margin:0 0 0 10px">{{ itemDetail.statis.onlookerCnt }}次围观</span>
      </div>
    </div>
    <div class="bottom d_flex justify_content_sb">

      <div class="d_flex  flex_direction_col fz14 c_808080" style="width:100%;flex-basis:60%">

        <div
          v-if="isDealing"
          class="apply_intention fz12 text_center c_fff"
          :class="isApply?'cursor_pointer bc_0983CC ':'disable_btn'"
          @click="onIntentionApplyClick"
        >
          <span>提交报名意向</span>
        </div>

        <!-- 元信息 -->
        <div class="d_flex justify_content_sb">
          <div class="field_col flex_1">
            <div class="item_c">
              <span>项目编号：</span>
              <span>{{ itemDetail.projectNo }}</span>
            </div>
            <div class="item_c">
              <span>招标类型：</span>
              <span>{{ biddingTypeKey[itemDetail.biddingType] }}</span>
            </div>
          </div>

          <div class="field_col flex_1">
            <div class="item_c">
              <span>资金性质：</span>
              <span>{{ capitalPropertyKey[itemDetail.capitalProperty] }}</span>
            </div>
            <div class="item_c">
              <span>价格：</span>
              <span>{{ itemDetail.currentPrice }}{{ itemDetail.priceUnitDesc }}<span v-if="itemDetail.priceUnit==='zongjia'">({{ priceUnitKey[itemDetail.priceUnit] }})</span></span>
            </div>
          </div>
        </div>

      </div>

      <div style="width:100%;flex-basis:40%" class="text_right">
        <img v-if="isDealed" src="@/assets/images/p_item_6.png" alt="">
        <img v-if="isDealing" src="@/assets/images/p_item_5.png" alt="">
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { intention_apply } from '@/api/user'
export default {
  components: {
  },
  props: {
    itemDetail: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapGetters(['isLogin', 'priceUnitKey', 'biddingTypeKey', 'capitalPropertyKey']),
    // 已交易
    isDealed() {
      return this.itemDetail.state === 4
    },
    // 待交易
    isDealing() {
      return this.itemDetail.state === 3
    },
    // 是否可报名
    isApply() {
      return this.itemDetail.apply
    }

  },

  created() {
    console.log(this.itemDetail)
  },
  methods: {
    // 提交意向报名 click
    onIntentionApplyClick() {
      if (!this.isApply) return

      if (!this.isLogin) {
        this.$router.push({
          path: '/login',
          query: {
            returnUrl: this.$route.fullPath
          }
        })
      } else {
        this.apply()
      }
    },
    // 意向报名 api
    async apply() {
      try {
        const res = await intention_apply(this.itemDetail.projectNo)
        if (res.code === 200) {
          this.$notify({
            message: '提交成功',
            type: 'success'
          })
        }
      } catch (err) {
        // console.log('emit onRefesh')
        // this.$emit('onRefesh')
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.disable_btn{
  cursor: not-allowed;
  background-color: #ccc;
}

.notice_w{
  width: 100%;
  border: 1px solid #E6E6E6;
  margin: 0 0 0 10px;
.top{
  height: 100px;
  line-height: 100px;
  padding: 0 20px;
  border-bottom: 1px solid #E6E6E6;
}
::v-deep .bottom{
  padding: 30px 20px;
  .field_col{
    margin: 0 10px 0 0;
  }
  .item_c{
    margin: 0 0 30px 0;
    white-space: nowrap;
  }
  .apply_intention{
    width: 182px;
    height: 40px;
    line-height: 40px;
    margin: 0 0 44px 0;
  }
}
}
</style>
